<!--
This component is a STUB.
It is not the real thing.
Meant to help us make the app look like IMPERIA
-->

<template>
  <div class="i-navbar-header i-col-xs-12">
    <a
      href="#"
      class="i-css-hide-menu-link i-css-left i-main-menu-class"
      @click.prevent="toggleMenu"
      style="background-color: "
    >
      <i class="fa5 fas fa-bars large-white-middle" name="bars"></i>
    </a>
    <div class="left">
      <p style="display: none" class="i_version">10</p>
      <a href="/#/" class="i-navbar-brand" title="Version 11.2.3">
        <img
          src="/images/i10-logo.png"
          width="97"
          height="30"
          alt="CMS Imperia"
          style="max-width: none"
        />
      </a>
    </div>
    <div class="top-nav i-css-right">
      <div
        class="favorites_container i-favorites-sortable i-css-left ui-sortable"
        id="favorites_container"
      >
        <div
          class="rel_wrapper i-favorite-item ui-sortable-handle"
          data-node-id="/navigation/favorites"
        >
          <a href="/imp/navigation/favorites" title="Edit user favorites">
            <i class="fa5 fas fa-star" name="star"></i>
          </a>
        </div>
        <div
          class="rel_wrapper i-favorite-item ui-sortable-handle"
          data-node-id="/structure/categories"
        >
          <a
            href="/imp/structure/categories"
            title="Installation of website categories"
          >
            <i class="fa5 fas fa-folders" name="folders"></i>
          </a>
        </div>
        <div
          class="rel_wrapper i-favorite-item ui-sortable-handle"
          data-node-id="/structure/workflow"
        >
          <a href="/imp/structure/workflow" title="Workflow Manager">
            <i class="fa5 fas fa-project-diagram" name="project-diagram"></i>
          </a>
        </div>
      </div>
      <div class="top-nav-icon i-css-bookmark i-css-left">
        <a
          href="/imp/navigation/favorites/add/document/media"
          title="Add to favorites"
          class="i-favorite i-action-add"
        >
          <i class="fa5 fas fa-star far" name="star"></i>
        </a>
        <a
          href="/imp/navigation/favorites/remove/document/media"
          style="display: none"
          title="Remove favorite"
          class="i-favorite i-action-remove"
        >
          <i class="fa5 fas fa-star" name="star"></i>
        </a>
      </div>
      <div class="top-nav-icon i-css-mailer i-css-left">
        <div class="rel_wrapper notification-container">
          <a href="/imp/system/mailer" title="Internal Mail">
            <i class="fa5 fas fa-envelope" name="envelope"></i>
          </a>
        </div>
      </div>
      <div class="top-nav-icon i-css-addons i-css-left">
        <div class="rel_wrapper">
          <a href="/imp/dev/addons" title="Add-ons">
            <i class="fa5 fas fa-puzzle-piece" name="puzzle-piece"></i>
          </a>
        </div>
      </div>
      <div class="top-nav-icon i-css-help i-css-left">
        <div class="rel_wrapper">
          <a href="#" title="Online Help: Media-Asset-Management" class="block_link">
            <span class="i-css-user-settings-nav-label">
              <i class="fa5 fas fa-question-circle" name="question-circle"></i>
            </span>
          </a>
        </div>
      </div>
      <div class="top-nav-icon i-css-user-settings i-css-left">
        <ul class="i-css-user-settings-nav">
          <li class="i-css-settings-nav">
            <a
              href="#"
              id="i-user-settings-menu"
              title="User menu"
              aria-label="User menu"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i
                aria-hidden="true"
                title="User menu"
                class="fa5 fas fa-cog fas"
                name="cog"
              ></i>
              <span class="sr-only">User menu</span>
            </a>
            <ul
              class="i-css-user-settings-nav-inner"
              role="menu"
              aria-labelledby="i-user-settings-menu"
            >
              <li class="i-css-settings-nav-inner" role="menuitem">
                <a
                  href="/imp/roles/user/profile"
                  title="User settings"
                  class="block_link"
                >
                  <span class="i-css-user-settings-nav-label">
                    <i class="fa5 fas fa-user" name="user"></i>
                    superuser
                  </span>
                </a>
              </li>
              <li class="i-css-settings-nav-inner" role="menuitem">
                <a
                  href="/imp/roles/adopt_role"
                  title="Available Groups"
                  class="block_link"
                >
                  <span class="i-css-user-settings-nav-label">
                    <i class="fa5 fas fa-users" name="users"></i>
                    Available Groups
                  </span>
                </a>
              </li>
              <li class="i-css-settings-nav-inner" role="menuitem">
                <a href="/imp/system/info" title="Info" class="block_link">
                  <span class="i-css-user-settings-nav-label">
                    <i class="fa5 fas fa-info-circle" name="info-circle"></i>
                    About
                  </span>
                </a>
              </li>
              <li class="i-css-settings-nav-inner" role="menuitem">
                <a
                  href="/imp/system/logout"
                  title="Logout"
                  class="block_link logout"
                >
                  <span class="i-css-user-settings-nav-label">
                    <i class="fa5 fas fa-power-off" name="power-off"></i>
                    logout
                  </span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <form
        action="/imp/document/search_devel"
        class="top-search i-css-left"
        method="post"
        id="search"
        role="search"
      >
        <input
          alt=""
          type="text"
          name="search"
          value="Search"
          class="search_field"
          aria-label="Search"
        />
        <button
          type="submit"
          title="Search"
          name="button"
          class="search-fa-btn"
        >
          <i class="fa5 fas fa-search" name="search"></i>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // mimic Imperia behavior:
    // the visibility state is currently controlled in the JQ world
    // the source-of-truth is a jQ 'data' prop called 'visible'
    // See: site/view/imperia/default/layout/header.html
    // See: site/view/imperia/default/layout/vue_mainmenu.html
    const $hamburger = $('.i-main-menu-class'); // eslint-disable-line
    // set initial menu visibility state (always on by default in dev mode)
    $hamburger.data('visible', true);
  },
  methods: {
    toggleMenu() {
      const $hamburger = $('.i-main-menu-class'); // eslint-disable-line
      const visible = Boolean($hamburger.data('visible'));
      $hamburger.data('visible', !visible);
      $(document).trigger('i-main-menu-toggle', { state: !visible }); // eslint-disable-line
    },
  },
};
</script>
